<template>
  <div ref="chatMessages" class="chat-messages">
    <div class="chat-messages-list">
      <div
        v-for="(message, index) in messages"
        :key="message.id"
        class="chat-messages-list-item"
      >
        <div
          v-if="index === 0 || moment(message.dateMessage).format('DD/MM/YYYY') !== moment(messages[index - 1].dateMessage).format('DD/MM/YYYY')"
          class="chat-messages-day"
        >
          <p>
            {{ moment(message.dateMessage).format('DD/MM/YYYY') }}
          </p>
        </div>
        <ChatMessage
          :to="message.to"
          :type="message.type"
          :message="message.message"
          :fileBase="message.fileBase"
          :mimeType="message.mimeType"
          :date="message.dateMessage"
          :sent="message.sent"
          :description="message.description"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ChatMessage from './ChatMessage.vue'

export default {
  name: 'ChatMessages',
  components: {
    ChatMessage
  },
  props: {
    messages: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    scrollToBottom () {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.chatMessages.scrollTop = this.$refs.chatMessages.scrollHeight
        }, 10)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/chat/ChatMessages.vue